import { render, staticRenderFns } from "./text-formatted.vue?vue&type=template&id=7e87102a&scoped=true"
import script from "./text-formatted.vue?vue&type=script&lang=js"
export * from "./text-formatted.vue?vue&type=script&lang=js"
import style0 from "./text-formatted.vue?vue&type=style&index=0&id=7e87102a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e87102a",
  null
  
)

export default component.exports